import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.5 9v10.5c0 .5.4 1 1 1h10c.5 0 1-.5 1-1V9m-6-3.5v-2m-1.5 0h3m-9.5 4h16l-1.4-2H4.9l-1.4 2z" stroke="currentColor" fill="none" /></svg>;